<template>
  <div>
    <b-card :title="$t('common.ivf-balance')">
      <div>
        <b-row>
          <b-col cols="12" md="12" class="mt-3"> </b-col>

          <b-col md="5" cols="6">
            <b-form-group :label="$t('common.from-date')" label-for="date">
              <b-form-datepicker
                id="example-datepicker"
                v-model="dateFrom"
                class="mb-2"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col md="5" cols="6">
            <b-form-group :label="$t('common.to-date')" label-for="date">
              <b-form-datepicker
                id="example-datepicker2"
                v-model="dateTo"
                class="mb-2"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col md="2" cols="6" style="margin-top: 22px">
            <b-button variant="primary" @click="getAccountingBalance()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-2 mt-3">
          <b-col md="6" cols="6">
            <h4 style="display: inline">
              {{ $t("common.balance-amount-iqd-sum") }}:
            </h4>
            <h3 style="display: inline">
              <b-badge
                :variant="balance.amount_iqd_sum > 0 ? 'success' : 'danger'"
                >{{ formatIQDCurrency(balance.amount_iqd_sum) }}</b-badge
              >
            </h3>
          </b-col>
          <b-col md="6" cols="6">
            <h4 style="display: inline">
              {{ $t("common.balance-amount-usd-sum") }}:
            </h4>
            <h3 style="display: inline">
              <b-badge
                :variant="balance.amount_usd_sum > 0 ? 'success' : 'danger'"
                >{{ formatUSDCurrency(balance.amount_usd_sum) }}</b-badge
              >
            </h3>
          </b-col>
          <b-col md="0" cols="12">
            <br />
          </b-col>
          <b-col md="6" cols="6">
            <p class="text-muted font-weight-bold">
              {{ $t("common.this-sums-based-on-the-selected-date") }}
            </p>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <!-- <b-button variant="primary" @click="getAccountingBalance()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button> -->
            <!-- <b-button variant="primary" v-print="IVF" class="mx-2">
              {{ $t("surgery.Print-Hospital-Expenses") }}
            </b-button> -->
          </b-col>
        </b-row>

        <!-- Data Table  -->

        <b-tabs content-class="mt-3" pills fill>
          <b-tab :title="$t('common.ivf-expenses')">
            <div class="d-flex justify-content-between mt-5 mb-2">
              <h2 class="mb-2 mt-1">{{ $t("common.ivf-expenses") }}</h2>
              <b-row class="mt-1" style="width: 500px">
                <b-col md="6" cols="6">
                  <b-form-group
                    :label="$t('common.amount-iqd-sum')"
                    label-for="name"
                    style=""
                  >
                    <h4>
                      <b-badge variant="primary">{{
                        formatIQDCurrency(sumsExpense.amount_iqd_sum)
                      }}</b-badge>
                    </h4>
                  </b-form-group>
                </b-col>
                <b-col md="6" cols="6">
                  <b-form-group
                    :label="$t('common.amount-usd-sum')"
                    label-for="name"
                  >
                    <h4>
                      <b-badge variant="primary">{{
                        formatUSDCurrency(sumsExpense.amount_usd_sum)
                      }}</b-badge>
                    </h4>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <b-table
              :items="expenseData"
              responsive
              :fields="expensesColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(amount_iqd)="data">
                <span class="text-nowrap font-weight-bolder">
                  {{ formatIQDCurrency(data.item.amount_iqd) }}
                </span>
              </template>
              <template #cell(amount_usd)="data">
                <span class="text-nowrap font-weight-bolder">
                  {{ formatUSDCurrency(data.item.amount_usd) }}
                </span>
              </template>

              <template #cell(currency_ex_rate)="data">
                <span class="text-nowrap">
                  {{ data.item.currency_ex_rate }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >Showing 1 to 10 Hospital Expenses</span
                  >
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getAccountingBalance()"
                >
                  <b-pagination
                    v-model="pageExpense"
                    :total-rows="dataCountExpense"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab :title="$t('common.ivf-income')">
            <div class="d-flex justify-content-between mt-5 mb-2">
              <h2 class="mb-2 mt-1">{{ $t("common.ivf-income") }}</h2>
              <b-row class="mt-1" style="width: 500px">
                <b-col md="6" cols="6">
                  <b-form-group
                    :label="$t('common.amount-iqd-sum')"
                    label-for="name"
                    style=""
                  >
                    <h4>
                      <b-badge variant="primary">{{
                        formatIQDCurrency(sumsIncome.amount_iqd_sum)
                      }}</b-badge>
                    </h4>
                  </b-form-group>
                </b-col>
                <b-col md="6" cols="6">
                  <b-form-group
                    :label="$t('common.amount-usd-sum')"
                    label-for="name"
                  >
                    <h4>
                      <b-badge variant="primary">{{
                        formatUSDCurrency(sumsIncome.amount_usd_sum)
                      }}</b-badge>
                    </h4>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <b-table
              :items="incomeData"
              responsive
              :fields="incomeColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(amount_iqd)="data">
                <span class="text-nowrap font-weight-bolder">
                  {{ formatIQDCurrency(data.item.amount_iqd) }}
                </span>
              </template>
              <template #cell(amount_usd)="data">
                <span class="text-nowrap font-weight-bolder">
                  {{ formatUSDCurrency(data.item.amount_usd) }}
                </span>
              </template>

              <template #cell(currency_ex_rate)="data">
                <span class="text-nowrap">
                  {{ data.item.currency_ex_rate }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner :label="$t('common.loading')" />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >Showing 1 to 10 Hospital Income</span
                  >
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getAccountingBalance()"
                >
                  <b-pagination
                    v-model="pageIncome"
                    :total-rows="dataCountIncome"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>

    <IVF :data="data" type="Hospital" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BTab,
  BTabs,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const IVF = () => import("@/components/printables/IVF.vue");
const Doctor = () => import("@/components/printables/Doctor.vue");
import permissionChecker from "@/mixins/permissionChecker";

export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    Doctor,
    BFormSelect,
    BFormDatepicker,
    BTabs,
    BTab,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      isNotValid: false,
      dataCountIncome: 0,
      dataCountExpense: 0,
      data: [],
      EditForm: {
        amount_iqd: "",
        amount_usd: "",
        description: "",
        date: "",
        currency_ex_rate: 0,
        _method: "PUT",
        name: "ahmed",
      },
      createMode: false,
      errorForm: {
        amount_iqd: "",
        amount_usd: "",
        description: "",
        date: "",
      },
      params: {
        form: {},
        path: "",
      },
      expensesColumns: [
        {
          key: "name",
          sortable: true,
          label: this.$t("common.name"),
        },
        {
          key: "amount_iqd",
          sortable: true,
          label: this.$t("common.Amount-IQD"),
        },
        {
          key: "amount_usd",
          sortable: true,
          label: this.$t("common.Amount-USD"),
        },
        {
          key: "description",
          sortable: true,
          label: this.$t("common.description"),
        },
        {
          key: "currency_ex_rate",
          sortable: true,
          label: this.$t("common.Exchange-Rate"),
        },

        {
          key: "date",
          sortable: true,
          label: this.$t("common.Date"),
          thStyle: { width: "150px" },
        },
        // { key: "created_at", sortable: true, label: this.$t("common.created_at") },
        //  { key: "Actions", label: this.$t("common.actions") },
      ],
      incomeColumns: [
        {
          key: "name",
          sortable: true,
          label: this.$t("common.name"),
        },
        {
          key: "amount_iqd",
          sortable: true,
          label: this.$t("common.Amount-IQD"),
        },
        {
          key: "amount_usd",
          sortable: true,
          label: this.$t("common.Amount-USD"),
        },
        {
          key: "description",
          sortable: true,
          label: this.$t("common.description"),
        },
        {
          key: "currency_ex_rate",
          sortable: true,
          label: this.$t("common.Exchange-Rate"),
        },

        {
          key: "date",
          sortable: true,
          label: this.$t("common.Date"),
          thStyle: { width: "150px" },
        },
        // { key: "created_at", sortable: true, label: this.$t("common.created-at") },
        // { key: "Actions", label: this.$t("common.actions") },
      ],
      currency: "USD",
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      pageIncome: 1,
      pageExpense: 1,
      expenses: "Hospital Expenses",
      IVF: {
        id: "IVF",
      },
      DOCTOR: {
        id: "Doctor",
      },
      DoctorList: [],
      dateFrom: "",
      dateTo: "",
      sumsIncome: {
        amount_iqd_sum: 0,
        amount_usd_sum: 0,
      },
      sumsExpense: {
        amount_iqd_sum: 0,
        amount_usd_sum: 0,
      },
      incomeData: null,
      expenseData: null,
      balance: {
        amount_iqd_sum: 0,
        amount_usd_sum: 0,
      },
    };
  },
  mounted() {
    const today = new Date();
    this.dateFrom = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-01`;
    this.getAccountingBalance();
  },
  watch: {},
  methods: {
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          amount_iqd: "",
          amount_usd: "",
          description: "",
          date: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.name = item.name;
        this.EditForm.id = item.id;
        this.EditForm.amount_iqd = item.amount_iqd;
        this.EditForm.amount_usd = item.amount_usd;
        this.EditForm.description = item.description;
        this.EditForm.date = item.date;
        if (this.expenses == "Doctors Expenses") {
          this.EditForm.doctor_id = item.doctor_id;
        }

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getAccountingBalance() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/ivfAccountingBalance?page=${this.page}&take=${
        this.dateFrom ? 1000 : 100
      }&sort=-id`;

      if (this.dateFrom) {
        // console.log("this.dateFrom", this.dateFrom);
        url += `&filter[date-ge]=${this.dateFrom}`;
      }
      if (this.dateTo) {
        url += `&filter[date-le]=${this.dateTo}`;
      }

      await this.getList(url);
      this.incomeData = this.all_data.incomes.data;
      this.expenseData = this.all_data.expenses.data;

      this.balance.amount_iqd_sum = this.all_data.balance.amount_iqd_balance;
      this.balance.amount_usd_sum = this.all_data.balance.amount_usd_balance;

      this.dataCountIncome = this.all_data.incomes.pagination.total;
      this.dataCountExpense = this.all_data.expenses.pagination.total;
      // console.log("this.dataCountIncome", this.dataCountIncome);
      // console.log("this.dataCountExpense", this.dataCountExpense);
      this.pageIncome = this.all_data.incomes.pagination.current_page;
      this.pageExpense = this.all_data.expenses.pagination.current_page;
      // console.log("this.pageIncome", this.pageIncome);
      // console.log("this.pageExpense", this.pageExpense);
      this.sumsIncome.amount_iqd_sum =
        this.all_data.incomes.sums.amount_iqd_sum;
      this.sumsIncome.amount_usd_sum =
        this.all_data.incomes.sums.amount_usd_sum;

      this.sumsExpense.amount_iqd_sum =
        this.all_data.expenses.sums.amount_iqd_sum;
      this.sumsExpense.amount_usd_sum =
        this.all_data.expenses.sums.amount_usd_sum;

      // console.log("this.sumsExpense", this.sumsExpense);
      // console.log("this.sumsIncome", this.sumsIncome);
      this.data = this.all_data.data;
      this.loading = false;
    },

    formatIQDCurrency(value) {
      // console.log("value", value);
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IQD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      // Format the value and return it
      return formatter.format(value);
    },
    formatUSDCurrency(value) {
      // Ensure the value is a number and format it to one decimal place
      const formattedValue = Number(value).toFixed(1);

      // Create a new Intl.NumberFormat object for USD currency without cents
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

      // Format the value and return it
      return formatter.format(formattedValue);
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
